import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// CSRF: Axios (and Inertia, which uses this same instance) sends the XSRF-TOKEN cookie as
// X-XSRF-TOKEN on every same-origin request, read at request time. Do not set X-CSRF-TOKEN here:
// Laravel prefers it over X-XSRF-TOKEN and a page-load copy goes stale when login/logout rotates it.
